module.exports = tv4;


//////////////////
// WEBPACK FOOTER
// external "tv4"
// module id = 12
// module chunks = 0